import { useEffect, useState } from "react";
import { Download, FilePieChart, FileText } from "lucide-react";
import { api } from "../../lib/api";

export default function Reportes() {
    const [students, setStudents] = useState([]);
    const [results, setResults] = useState([]);
    const [downloadingPdf, setDownloadingPdf] = useState(false);

    useEffect(() => {
        async function load() {
            const s = await api.get("/users", { params: { role: "alumno" } });
            setStudents(s.data || []);
            const exams = await api.get("/exams");
            const all = [];
            for (const e of exams.data || []) {
                try {
                    const r = await api.get(`/exams/${e.id}/results`);
                    all.push(...(r.data || []));
                } catch (_) {}
            }
            setResults(all);
        }
        load();
    }, []);

    function downloadCSV() {
        const rows = [["Alumno", "Examen", "Materia", "Nota"]];
        results.forEach((r) => rows.push([r.user_name, r.exam_title, r.subject, `${r.score_percent}%`]));
        const csv = rows.map((r) => r.join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "reporte_eduperu.csv";
        a.click();
        URL.revokeObjectURL(url);
    }

    async function downloadPDF() {
        setDownloadingPdf(true);
        try {
            const resp = await api.get("/reports/admin/pdf", { responseType: "blob" });
            const url = URL.createObjectURL(resp.data);
            const a = document.createElement("a");
            a.href = url;
            a.download = "reporte_eduperu.pdf";
            a.click();
            URL.revokeObjectURL(url);
        } finally {
            setDownloadingPdf(false);
        }
    }

    return (
        <div className="p-6 md:p-10 fade-in" data-testid="admin-reportes-page">
            <h1 className="text-3xl font-semibold mb-1">Reportes</h1>
            <p className="text-edu-body mb-6">Descarga reportes de actividad y rendimiento.</p>

            <div className="grid md:grid-cols-2 gap-5 mb-6">
                <Card label="Total Alumnos" value={students.length} />
                <Card label="Exámenes registrados" value={results.length} />
                <Card
                    label="Promedio general"
                    value={
                        results.length
                            ? Math.round(results.reduce((a, b) => a + b.score_percent, 0) / results.length) + "%"
                            : "—"
                    }
                />
                <Card
                    label="Monedas totales"
                    value={students.reduce((a, s) => a + (s.coin_balance || 0), 0)}
                />
            </div>

            <div className="flex flex-wrap gap-3">
                <button
                    onClick={downloadPDF}
                    disabled={downloadingPdf}
                    className="edu-btn-primary inline-flex items-center gap-2 px-5 py-2.5 text-sm disabled:opacity-50"
                    data-testid="download-pdf"
                >
                    <FileText size={14} /> {downloadingPdf ? "Generando…" : "Descargar PDF"}
                </button>
                <button
                    onClick={downloadCSV}
                    className="px-5 py-2.5 rounded-xl border border-edu inline-flex items-center gap-2 text-sm hover:bg-gray-50"
                    data-testid="download-csv"
                >
                    <Download size={14} /> Descargar CSV
                </button>
            </div>
        </div>
    );
}

function Card({ label, value }) {
    return (
        <div className="edu-card p-6">
            <FilePieChart size={20} className="text-edu-navy mb-2" />
            <div className="text-xs uppercase tracking-widest text-edu-muted font-semibold">{label}</div>
            <div className="text-3xl font-bold mt-1">{value}</div>
        </div>
    );
}
